/* Custom Contact - tabs */

if (window.location.href.indexOf("/pages/contact-us") > -1) {
  if (window.location.href.indexOf("/pages/contact-us#marketingForm") > -1) {
    document.querySelector("#tab2").click();
    const tabsElement = document.querySelector('.tabs');
    if (tabsElement) {
      const topPosition = tabsElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetTop = topPosition - 160;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  } else if (window.location.href.indexOf("/pages/contact-us#merchandisingForm") > -1) {
    document.querySelector("#tab3").click();
    const tabsElement = document.querySelector('.tabs');
    if (tabsElement) {
      const topPosition = tabsElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetTop = topPosition - 160;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  }

  window.onhashchange = function (event) {
    event.preventDefault();
    var newURL = event.newURL;

    if (newURL.indexOf("/pages/contact-us#marketingForm") > -1) {
      document.querySelector("#tab2").click();
      const tabsElement = document.querySelector('.tabs');
      if (tabsElement) {
        const topPosition = tabsElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetTop = topPosition - 160;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    } else if (newURL.indexOf("/pages/contact-us#merchandisingForm") > -1) {
      document.querySelector("#tab3").click();
      const tabsElement = document.querySelector('.tabs');
      if (tabsElement) {
        const topPosition = tabsElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetTop = topPosition - 160;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }
  }
}